<template>
  <div id="app" v-bind:class="{ 'profil-2': !isMale, 'profil-1': isMale }">
    <loader></loader>
    <message></message>
    <loginControl></loginControl>
    <slideout-panel></slideout-panel>
    <component :is="layout">
      <transition name="fadeRoute">
        <router-view :key="$route.fullPath" class="router-content" />
      </transition>
    </component>
  </div>
</template>

<script>

import service from '@/service'
const Loader = () => import('@/shared/widget/loader')
const Message = () => import('@/shared/widget/message')
const LoginControl = () => import('@/shared/widget/loginControl')

export default {
  name: 'App',
  components: {
    Loader, Message, LoginControl
  },
  data () {
    return {
    }
  },
  mounted () {
    service.customer.trace(this, this.eventHub).then(function (data) {
      if (data != null && data.encodedToken !== null && data.encodedToken === 'off') {
        window.setRecaptchaInfo(data.encodedToken)
      } else {
        window.setRecaptchaInfo('')
      }
    })
  },
  methods: {
    goHome: function () {
      if (this.$route.meta.isPost) {
        this.$router.push({ name: 'Personal' })
      } else {
        this.$router.go(0)
      }
    },
    closeBrowserTab: function () {
      this.$router.push({ name: 'HomePage' })
      // window.close()
    }
  },
  computed: {
    layout () {
      if (this.$route.name !== null) {
        return (this.$route.meta.layout || 'default') + '-layout'
      } else {
        return 'empty-layout'
      }
    },
    isMale: function () {
      return Math.random() >= 0.5
    }
  },
  created: function () {
    this.eventHub.$on('logout', this.closeBrowserTab)
  },
  beforeDestroy: function () {
    this.eventHub.$off('logout', this.closeBrowserTab)
  }
}
window.onload = function () {
  window.scrollTo(0, 0)
}
</script>

<style>  .header-fixed {
    position: fixed;
    right: 0;
    left: 0;
  }

  .router-content {
    background-color: var(--light-bg1);
  }

  .slideout-panel .slideout-wrapper .slideout.open-on-right.slideIn-enter-to {
    transform: none;
  }
</style>



// WEBPACK FOOTER //
// src/desktopApp.vue